import api from '@/utils/api';
import { menu, routers, authMenu, authRoutes } from '@/utils/config';
import { QueryCustPage } from '../../../request/cust';
export default {
    namespace: true,
    state: {
        custList: [],
        custPage: {}
    },
    mutations: {
        SET_CUST_PAGE(state, custPage) {
            state.custPage = custPage;
        },

        SET_CUST_LIST(state, custList) {
            state, (custList = custList);
        }
    },
    actions: {
        QUERY_CUST_PAGE: async ({ commit }, payload) => {
            let res = await QueryCustPage(payload);
            if (res?.code == 200) {
                commit('SET_CUST_PAGE', res.data ?? {});
            } else {
                commit('SET_CUST_PAGE', {});
            }
            return res;
        },

        QUERY_CUST_LIST: async ({ commit }, payload) => {}
    }
};
